export const iconSize = {
  xs: 8,
  sm: 16,
  md: 24,
  lg: 32,
  xl: 64,
} as const;

export type IconSizeKey = keyof typeof iconSize;
